import React from "react";
import { NavLink } from "react-router-dom";
import classes from "../MngCommon.module.css";

function MngProductNavigation(/* props */) {
    return (
        <div className={classes.admin_sub_nav}>
            <nav>
                <ul className={classes.depth_1}>
                    <li className={classes.depth_1_link}>
                        <NavLink to="category">카테고리 관리</NavLink>
                    </li>

                    <li className={classes.depth_1_link}>
                        <NavLink to="list">상품목록</NavLink>
                    </li>
                    <li className={classes.depth_1_link}>
                        <NavLink to="smartFilter">상품정보/스마트필터관리</NavLink>
                    </li>
                    <li className={classes.depth_1_link}>
                        <NavLink to="display">상품전시관리</NavLink>
                    </li>
                </ul>
            </nav>
        </div>
    );
}

export default MngProductNavigation;
